import React from 'react';
import Tooltip from "./Tooltip";
import styled from "styled-components";
import StringFormatter from "../utils/StringFormatter";
const TextInfoTooltip = (props) => {
    const { parameters, text } = props;
    let outputText = text;
    if (typeof text === 'string') {
        outputText = StringFormatter(text, parameters);
    }
    return React.createElement(Tooltip, { HeaderIcon: React.createElement(InfoIcon, null), IconWrapper: InfoIconWrapper, children: outputText, ...props });
};
const InfoIcon = styled.span `

    &:before {
        position: absolute;

        left: 6px;
        top: 2px;
        width: 2px;
        height: 2px;

        border-radius: 3px;
        background-color: ${props => props.theme.colors.white};

        content: '';
    }

    &:after {
        position: absolute;

        left: 6px;
        top: 5px;
        width: 2px;
        height: 7px;

        border-radius: 3px;
        background-color: ${props => props.theme.colors.white};

        content: '';
    }
`;
const InfoIconWrapper = styled("div") `
    display: inline-block;
    position: relative;
    height: 14px;
    width: 14px;

    border-radius: 4px;
    background-color: ${props => props.isOpen ? props.theme.colors.blueLight : props.theme.colors.silver};
`;
export default TextInfoTooltip;
//# sourceMappingURL=TextInfoTooltip.js.map